// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               unknown
// source: photon/imessage/v1/poll_service.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import type { CallContext, CallOptions } from "nice-grpc-common";
import { PollChangeEvent, PollInfo } from "./poll_types.js";
import { Heartbeat } from "./streaming.js";

export const protobufPackage = "photon.imessage.v1";

export interface CreatePollRequest {
  chatGuid: string;
  title: string;
  options: string[];
  clientMessageId?: string | undefined;
}

export interface PollResponse {
  poll: PollInfo | undefined;
}

export interface VotePollRequest {
  pollMessageGuid: string;
  optionIdentifier: string;
  clientMessageId?: string | undefined;
}

export interface UnvotePollRequest {
  pollMessageGuid: string;
  clientMessageId?: string | undefined;
}

export interface AddPollOptionRequest {
  pollMessageGuid: string;
  optionText: string;
  clientMessageId?: string | undefined;
}

export interface GetPollRequest {
  pollMessageGuid: string;
}

export interface SubscribePollEventsRequest {
  /** Absent = subscribe to every poll the caller can observe. */
  pollMessageGuid?: string | undefined;
}

export interface SubscribePollEventsResponse {
  /**
   * Monotonic global sequence shared with `EventService.CatchUpEvents`
   * and every other `Subscribe*` stream. Absent on heartbeat frames.
   */
  sequence?: number | undefined;
  pollChanged?: PollChangeEvent | undefined;
  heartbeat?: Heartbeat | undefined;
}

function createBaseCreatePollRequest(): CreatePollRequest {
  return { chatGuid: "", title: "", options: [], clientMessageId: undefined };
}

export const CreatePollRequest: MessageFns<CreatePollRequest> = {
  encode(message: CreatePollRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    if (message.title !== "") {
      writer.uint32(18).string(message.title);
    }
    for (const v of message.options) {
      writer.uint32(26).string(v!);
    }
    if (message.clientMessageId !== undefined) {
      writer.uint32(802).string(message.clientMessageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreatePollRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreatePollRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.options.push(reader.string());
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.clientMessageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreatePollRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      options: globalThis.Array.isArray(object?.options) ? object.options.map((e: any) => globalThis.String(e)) : [],
      clientMessageId: isSet(object.clientMessageId)
        ? globalThis.String(object.clientMessageId)
        : isSet(object.client_message_id)
        ? globalThis.String(object.client_message_id)
        : undefined,
    };
  },

  toJSON(message: CreatePollRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.options?.length) {
      obj.options = message.options;
    }
    if (message.clientMessageId !== undefined) {
      obj.clientMessageId = message.clientMessageId;
    }
    return obj;
  },

  create(base?: DeepPartial<CreatePollRequest>): CreatePollRequest {
    return CreatePollRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreatePollRequest>): CreatePollRequest {
    const message = createBaseCreatePollRequest();
    message.chatGuid = object.chatGuid ?? "";
    message.title = object.title ?? "";
    message.options = object.options?.map((e) => e) || [];
    message.clientMessageId = object.clientMessageId ?? undefined;
    return message;
  },
};

function createBasePollResponse(): PollResponse {
  return { poll: undefined };
}

export const PollResponse: MessageFns<PollResponse> = {
  encode(message: PollResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.poll !== undefined) {
      PollInfo.encode(message.poll, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PollResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePollResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.poll = PollInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PollResponse {
    return { poll: isSet(object.poll) ? PollInfo.fromJSON(object.poll) : undefined };
  },

  toJSON(message: PollResponse): unknown {
    const obj: any = {};
    if (message.poll !== undefined) {
      obj.poll = PollInfo.toJSON(message.poll);
    }
    return obj;
  },

  create(base?: DeepPartial<PollResponse>): PollResponse {
    return PollResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PollResponse>): PollResponse {
    const message = createBasePollResponse();
    message.poll = (object.poll !== undefined && object.poll !== null) ? PollInfo.fromPartial(object.poll) : undefined;
    return message;
  },
};

function createBaseVotePollRequest(): VotePollRequest {
  return { pollMessageGuid: "", optionIdentifier: "", clientMessageId: undefined };
}

export const VotePollRequest: MessageFns<VotePollRequest> = {
  encode(message: VotePollRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pollMessageGuid !== "") {
      writer.uint32(10).string(message.pollMessageGuid);
    }
    if (message.optionIdentifier !== "") {
      writer.uint32(18).string(message.optionIdentifier);
    }
    if (message.clientMessageId !== undefined) {
      writer.uint32(802).string(message.clientMessageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VotePollRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVotePollRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pollMessageGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.optionIdentifier = reader.string();
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.clientMessageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VotePollRequest {
    return {
      pollMessageGuid: isSet(object.pollMessageGuid)
        ? globalThis.String(object.pollMessageGuid)
        : isSet(object.poll_message_guid)
        ? globalThis.String(object.poll_message_guid)
        : "",
      optionIdentifier: isSet(object.optionIdentifier)
        ? globalThis.String(object.optionIdentifier)
        : isSet(object.option_identifier)
        ? globalThis.String(object.option_identifier)
        : "",
      clientMessageId: isSet(object.clientMessageId)
        ? globalThis.String(object.clientMessageId)
        : isSet(object.client_message_id)
        ? globalThis.String(object.client_message_id)
        : undefined,
    };
  },

  toJSON(message: VotePollRequest): unknown {
    const obj: any = {};
    if (message.pollMessageGuid !== "") {
      obj.pollMessageGuid = message.pollMessageGuid;
    }
    if (message.optionIdentifier !== "") {
      obj.optionIdentifier = message.optionIdentifier;
    }
    if (message.clientMessageId !== undefined) {
      obj.clientMessageId = message.clientMessageId;
    }
    return obj;
  },

  create(base?: DeepPartial<VotePollRequest>): VotePollRequest {
    return VotePollRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VotePollRequest>): VotePollRequest {
    const message = createBaseVotePollRequest();
    message.pollMessageGuid = object.pollMessageGuid ?? "";
    message.optionIdentifier = object.optionIdentifier ?? "";
    message.clientMessageId = object.clientMessageId ?? undefined;
    return message;
  },
};

function createBaseUnvotePollRequest(): UnvotePollRequest {
  return { pollMessageGuid: "", clientMessageId: undefined };
}

export const UnvotePollRequest: MessageFns<UnvotePollRequest> = {
  encode(message: UnvotePollRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pollMessageGuid !== "") {
      writer.uint32(10).string(message.pollMessageGuid);
    }
    if (message.clientMessageId !== undefined) {
      writer.uint32(802).string(message.clientMessageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UnvotePollRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnvotePollRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pollMessageGuid = reader.string();
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.clientMessageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UnvotePollRequest {
    return {
      pollMessageGuid: isSet(object.pollMessageGuid)
        ? globalThis.String(object.pollMessageGuid)
        : isSet(object.poll_message_guid)
        ? globalThis.String(object.poll_message_guid)
        : "",
      clientMessageId: isSet(object.clientMessageId)
        ? globalThis.String(object.clientMessageId)
        : isSet(object.client_message_id)
        ? globalThis.String(object.client_message_id)
        : undefined,
    };
  },

  toJSON(message: UnvotePollRequest): unknown {
    const obj: any = {};
    if (message.pollMessageGuid !== "") {
      obj.pollMessageGuid = message.pollMessageGuid;
    }
    if (message.clientMessageId !== undefined) {
      obj.clientMessageId = message.clientMessageId;
    }
    return obj;
  },

  create(base?: DeepPartial<UnvotePollRequest>): UnvotePollRequest {
    return UnvotePollRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UnvotePollRequest>): UnvotePollRequest {
    const message = createBaseUnvotePollRequest();
    message.pollMessageGuid = object.pollMessageGuid ?? "";
    message.clientMessageId = object.clientMessageId ?? undefined;
    return message;
  },
};

function createBaseAddPollOptionRequest(): AddPollOptionRequest {
  return { pollMessageGuid: "", optionText: "", clientMessageId: undefined };
}

export const AddPollOptionRequest: MessageFns<AddPollOptionRequest> = {
  encode(message: AddPollOptionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pollMessageGuid !== "") {
      writer.uint32(10).string(message.pollMessageGuid);
    }
    if (message.optionText !== "") {
      writer.uint32(18).string(message.optionText);
    }
    if (message.clientMessageId !== undefined) {
      writer.uint32(802).string(message.clientMessageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddPollOptionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddPollOptionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pollMessageGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.optionText = reader.string();
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.clientMessageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddPollOptionRequest {
    return {
      pollMessageGuid: isSet(object.pollMessageGuid)
        ? globalThis.String(object.pollMessageGuid)
        : isSet(object.poll_message_guid)
        ? globalThis.String(object.poll_message_guid)
        : "",
      optionText: isSet(object.optionText)
        ? globalThis.String(object.optionText)
        : isSet(object.option_text)
        ? globalThis.String(object.option_text)
        : "",
      clientMessageId: isSet(object.clientMessageId)
        ? globalThis.String(object.clientMessageId)
        : isSet(object.client_message_id)
        ? globalThis.String(object.client_message_id)
        : undefined,
    };
  },

  toJSON(message: AddPollOptionRequest): unknown {
    const obj: any = {};
    if (message.pollMessageGuid !== "") {
      obj.pollMessageGuid = message.pollMessageGuid;
    }
    if (message.optionText !== "") {
      obj.optionText = message.optionText;
    }
    if (message.clientMessageId !== undefined) {
      obj.clientMessageId = message.clientMessageId;
    }
    return obj;
  },

  create(base?: DeepPartial<AddPollOptionRequest>): AddPollOptionRequest {
    return AddPollOptionRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AddPollOptionRequest>): AddPollOptionRequest {
    const message = createBaseAddPollOptionRequest();
    message.pollMessageGuid = object.pollMessageGuid ?? "";
    message.optionText = object.optionText ?? "";
    message.clientMessageId = object.clientMessageId ?? undefined;
    return message;
  },
};

function createBaseGetPollRequest(): GetPollRequest {
  return { pollMessageGuid: "" };
}

export const GetPollRequest: MessageFns<GetPollRequest> = {
  encode(message: GetPollRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pollMessageGuid !== "") {
      writer.uint32(10).string(message.pollMessageGuid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPollRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPollRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pollMessageGuid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPollRequest {
    return {
      pollMessageGuid: isSet(object.pollMessageGuid)
        ? globalThis.String(object.pollMessageGuid)
        : isSet(object.poll_message_guid)
        ? globalThis.String(object.poll_message_guid)
        : "",
    };
  },

  toJSON(message: GetPollRequest): unknown {
    const obj: any = {};
    if (message.pollMessageGuid !== "") {
      obj.pollMessageGuid = message.pollMessageGuid;
    }
    return obj;
  },

  create(base?: DeepPartial<GetPollRequest>): GetPollRequest {
    return GetPollRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetPollRequest>): GetPollRequest {
    const message = createBaseGetPollRequest();
    message.pollMessageGuid = object.pollMessageGuid ?? "";
    return message;
  },
};

function createBaseSubscribePollEventsRequest(): SubscribePollEventsRequest {
  return { pollMessageGuid: undefined };
}

export const SubscribePollEventsRequest: MessageFns<SubscribePollEventsRequest> = {
  encode(message: SubscribePollEventsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pollMessageGuid !== undefined) {
      writer.uint32(10).string(message.pollMessageGuid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubscribePollEventsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscribePollEventsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pollMessageGuid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubscribePollEventsRequest {
    return {
      pollMessageGuid: isSet(object.pollMessageGuid)
        ? globalThis.String(object.pollMessageGuid)
        : isSet(object.poll_message_guid)
        ? globalThis.String(object.poll_message_guid)
        : undefined,
    };
  },

  toJSON(message: SubscribePollEventsRequest): unknown {
    const obj: any = {};
    if (message.pollMessageGuid !== undefined) {
      obj.pollMessageGuid = message.pollMessageGuid;
    }
    return obj;
  },

  create(base?: DeepPartial<SubscribePollEventsRequest>): SubscribePollEventsRequest {
    return SubscribePollEventsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SubscribePollEventsRequest>): SubscribePollEventsRequest {
    const message = createBaseSubscribePollEventsRequest();
    message.pollMessageGuid = object.pollMessageGuid ?? undefined;
    return message;
  },
};

function createBaseSubscribePollEventsResponse(): SubscribePollEventsResponse {
  return { sequence: undefined, pollChanged: undefined, heartbeat: undefined };
}

export const SubscribePollEventsResponse: MessageFns<SubscribePollEventsResponse> = {
  encode(message: SubscribePollEventsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sequence !== undefined) {
      writer.uint32(8).uint64(message.sequence);
    }
    if (message.pollChanged !== undefined) {
      PollChangeEvent.encode(message.pollChanged, writer.uint32(82).fork()).join();
    }
    if (message.heartbeat !== undefined) {
      Heartbeat.encode(message.heartbeat, writer.uint32(794).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubscribePollEventsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscribePollEventsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.sequence = longToNumber(reader.uint64());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.pollChanged = PollChangeEvent.decode(reader, reader.uint32());
          continue;
        }
        case 99: {
          if (tag !== 794) {
            break;
          }

          message.heartbeat = Heartbeat.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubscribePollEventsResponse {
    return {
      sequence: isSet(object.sequence) ? globalThis.Number(object.sequence) : undefined,
      pollChanged: isSet(object.pollChanged)
        ? PollChangeEvent.fromJSON(object.pollChanged)
        : isSet(object.poll_changed)
        ? PollChangeEvent.fromJSON(object.poll_changed)
        : undefined,
      heartbeat: isSet(object.heartbeat) ? Heartbeat.fromJSON(object.heartbeat) : undefined,
    };
  },

  toJSON(message: SubscribePollEventsResponse): unknown {
    const obj: any = {};
    if (message.sequence !== undefined) {
      obj.sequence = Math.round(message.sequence);
    }
    if (message.pollChanged !== undefined) {
      obj.pollChanged = PollChangeEvent.toJSON(message.pollChanged);
    }
    if (message.heartbeat !== undefined) {
      obj.heartbeat = Heartbeat.toJSON(message.heartbeat);
    }
    return obj;
  },

  create(base?: DeepPartial<SubscribePollEventsResponse>): SubscribePollEventsResponse {
    return SubscribePollEventsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SubscribePollEventsResponse>): SubscribePollEventsResponse {
    const message = createBaseSubscribePollEventsResponse();
    message.sequence = object.sequence ?? undefined;
    message.pollChanged = (object.pollChanged !== undefined && object.pollChanged !== null)
      ? PollChangeEvent.fromPartial(object.pollChanged)
      : undefined;
    message.heartbeat = (object.heartbeat !== undefined && object.heartbeat !== null)
      ? Heartbeat.fromPartial(object.heartbeat)
      : undefined;
    return message;
  },
};

/**
 * Apple Polls (iOS 18+) authoring and observation.
 *
 * Every write returns the resulting `PollInfo` snapshot.
 *
 * Durable poll changes flow through `SubscribePollEvents`. For gap-free
 * reconnect, pair it with `EventService.CatchUpEvents`.
 */
export type PollServiceDefinition = typeof PollServiceDefinition;
export const PollServiceDefinition = {
  name: "PollService",
  fullName: "photon.imessage.v1.PollService",
  methods: {
    /** Writes */
    createPoll: {
      name: "CreatePoll",
      requestType: CreatePollRequest as typeof CreatePollRequest,
      requestStream: false,
      responseType: PollResponse as typeof PollResponse,
      responseStream: false,
      options: {},
    },
    votePoll: {
      name: "VotePoll",
      requestType: VotePollRequest as typeof VotePollRequest,
      requestStream: false,
      responseType: PollResponse as typeof PollResponse,
      responseStream: false,
      options: {},
    },
    unvotePoll: {
      name: "UnvotePoll",
      requestType: UnvotePollRequest as typeof UnvotePollRequest,
      requestStream: false,
      responseType: PollResponse as typeof PollResponse,
      responseStream: false,
      options: {},
    },
    addPollOption: {
      name: "AddPollOption",
      requestType: AddPollOptionRequest as typeof AddPollOptionRequest,
      requestStream: false,
      responseType: PollResponse as typeof PollResponse,
      responseStream: false,
      options: {},
    },
    /** Reads */
    getPoll: {
      name: "GetPoll",
      requestType: GetPollRequest as typeof GetPollRequest,
      requestStream: false,
      responseType: PollResponse as typeof PollResponse,
      responseStream: false,
      options: {},
    },
    /** Streams */
    subscribePollEvents: {
      name: "SubscribePollEvents",
      requestType: SubscribePollEventsRequest as typeof SubscribePollEventsRequest,
      requestStream: false,
      responseType: SubscribePollEventsResponse as typeof SubscribePollEventsResponse,
      responseStream: true,
      options: {},
    },
  },
} as const;

export interface PollServiceImplementation<CallContextExt = {}> {
  /** Writes */
  createPoll(request: CreatePollRequest, context: CallContext & CallContextExt): Promise<DeepPartial<PollResponse>>;
  votePoll(request: VotePollRequest, context: CallContext & CallContextExt): Promise<DeepPartial<PollResponse>>;
  unvotePoll(request: UnvotePollRequest, context: CallContext & CallContextExt): Promise<DeepPartial<PollResponse>>;
  addPollOption(
    request: AddPollOptionRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<PollResponse>>;
  /** Reads */
  getPoll(request: GetPollRequest, context: CallContext & CallContextExt): Promise<DeepPartial<PollResponse>>;
  /** Streams */
  subscribePollEvents(
    request: SubscribePollEventsRequest,
    context: CallContext & CallContextExt,
  ): ServerStreamingMethodResult<DeepPartial<SubscribePollEventsResponse>>;
}

export interface PollServiceClient<CallOptionsExt = {}> {
  /** Writes */
  createPoll(request: DeepPartial<CreatePollRequest>, options?: CallOptions & CallOptionsExt): Promise<PollResponse>;
  votePoll(request: DeepPartial<VotePollRequest>, options?: CallOptions & CallOptionsExt): Promise<PollResponse>;
  unvotePoll(request: DeepPartial<UnvotePollRequest>, options?: CallOptions & CallOptionsExt): Promise<PollResponse>;
  addPollOption(
    request: DeepPartial<AddPollOptionRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<PollResponse>;
  /** Reads */
  getPoll(request: DeepPartial<GetPollRequest>, options?: CallOptions & CallOptionsExt): Promise<PollResponse>;
  /** Streams */
  subscribePollEvents(
    request: DeepPartial<SubscribePollEventsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): AsyncIterable<SubscribePollEventsResponse>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export type ServerStreamingMethodResult<Response> = { [Symbol.asyncIterator](): AsyncIterator<Response, void> };

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
